import React from 'react';
import { Text, Box } from '@rsos/components/capstone/base';

const OutboundAlertsEmptyState = () => {
  return (
    <Box justify="center" align="center" height="100%" flow={4}>
      <Text size="large" color="secondaryText" fontWeight="semibold">
        No outbound pairs
      </Text>
      <Text size="normal" color="secondaryText">
        You are not currently sharing your alerts with any agencies.
      </Text>
    </Box>
  );
};

export default OutboundAlertsEmptyState;
